import React, { useState, useEffect, useRef } from "react";
import { Text, RichText, Image } from "@sitecore-jss/sitecore-jss-react";
import classNames from "classnames";
import { getOverallSettingsClasses, mobileIs, componentId } from "../../utils/siteUtils";
import "./style.scss";
const KeyFeaturesPoster = props => {
  const { lang, rendering, fields, page } = props;
  const { Title, Title_Mobile, SubTitle, SubTitle_Mobile, Key_Feature, Icon_Feature, Background_PC, Background_Mobile } = fields;
  const isMobile = mobileIs()
  const renderingClass = 'c-section-title' + '_' + rendering.dataSource;
  const rootId = componentId(rendering);
  const rootClasses = classNames("key-features-poster", renderingClass, getOverallSettingsClasses(fields));
  return (
    <div className={rootClasses} datasourceid={rendering.dataSource} id={rootId}>
    	{!isMobile && <div className="bg-img"><Image field={Background_PC} /></div>}
    	{isMobile &&  <div className="bg-img"><Image field={Background_Mobile} /></div>}
        
        <div className="text-content">
            <div className="q-container">
                <div className="kfp-title"><Text tag="h2" field={isMobile? Title_Mobile : Title }></Text></div>
                <div className="kfp-subtitle"><Text tag="p" field={isMobile? SubTitle_Mobile : SubTitle}></Text></div>
                <div className="kfp-hot-features">
                <ul>
                    {
                        Key_Feature?.map((item, index) => {
                            return <li key={index}><RichText field={isMobile? item?.fields?.Title_Mobile : item?.fields?.Title}></RichText></li>
                        })
                    }
                </ul>
                </div>

                <div className="kfp-icon-features">
                    <ul>
                        {
                            Icon_Feature?.map((item, index) => {
                                return <li key={index}>
                                    <div className="feature">
                                        <div className="icon">
                                            <Image field={item?.fields?.Icon} />
                                        </div>
                                        <div className="name">
                                            <Text tag="p" field={isMobile? item?.fields?.Title_Mobile : item?.fields?.Title} />
                                        </div>
                                        <div className="detail">
                                            <Text tag="p" field={isMobile? item?.fields?.Detail_Mobile : item?.fields?.Detail} />
                                        </div>
                                    </div>
                                </li>
                            })
                        }
                    </ul>
                </div>
            </div>
        </div>
    </div>
  );
};

export default 	KeyFeaturesPoster;